import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-enhanced-select',
  templateUrl: './enhanced-select.component.html',
  styleUrls: ['./enhanced-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: EnhancedSelectComponent,
      multi: true
    }
  ]
})
export class EnhancedSelectComponent implements OnInit, ControlValueAccessor {
  @Input() options: { value: any, label: string }[] = [];
  @Input() placeholder: string = 'Seleccionar...';
  @Input() disabled: boolean = false;
  
  @Output() selectionChange = new EventEmitter<any>();
  @ViewChild('searchInput') searchInput: ElementRef;
  
  selectedValue: any = null;
  searchTerm: string = '';
  showOptions: boolean = false;
  filteredOptions: { value: any, label: string }[] = [];
  selectedIndex: number = -1;

  private onChange: any = () => {};
  private onTouched: any = () => {};

  constructor() { }

  ngOnInit(): void {
    this.filteredOptions = [...this.options];
  }

  toggleOptionsDisplay(): void {
    this.showOptions = !this.showOptions;
    if (this.showOptions) {
      this.searchTerm = '';
      this.filteredOptions = [...this.options];
      setTimeout(() => {
        if (this.searchInput) {
          this.searchInput.nativeElement.focus();
        }
      });
    }
  }

  filterOptions(): void {
    if (!this.searchTerm) {
      this.filteredOptions = [...this.options];
      return;
    }
    
    const term = this.searchTerm.toLowerCase();
    this.filteredOptions = this.options.filter(option => 
      option.label.toLowerCase().includes(term)
    );
    this.selectedIndex = -1;
  }

  selectOption(option: { value: any, label: string }): void {
    this.selectedValue = option.value;
    this.onChange(this.selectedValue);
    this.onTouched();
    this.selectionChange.emit(this.selectedValue);
    this.showOptions = false;
  }
  
  clearSelection(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.selectedValue = null;
    this.onChange(this.selectedValue);
    this.onTouched();
    this.selectionChange.emit(this.selectedValue);
  }
  
  getDisplayText(): string {
    if (!this.selectedValue) return this.placeholder;
    
    const selected = this.options.find(option => option.value == this.selectedValue);
    return selected ? selected.label : this.placeholder;
  }
  
  selectFirstOption(event: Event): void {
    event.preventDefault();
    if (this.filteredOptions.length > 0) {
      this.selectOption(this.filteredOptions[this.selectedIndex !== -1 ? this.selectedIndex : 0]);
    }
  }
  
  navigateList(event: KeyboardEvent, direction: number): void {
    event.preventDefault();
    
    if (direction > 0) {
      this.selectedIndex = this.selectedIndex < this.filteredOptions.length - 1 ? this.selectedIndex + 1 : 0;
    } else {
      this.selectedIndex = this.selectedIndex > 0 ? this.selectedIndex - 1 : this.filteredOptions.length - 1;
    }
  }

  onSelectionChange(value: any): void {
    this.selectedValue = value;
    this.selectionChange.emit(this.selectedValue);
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
} 